// extracted by mini-css-extract-plugin
module.exports = {"block-pane":"block-pane__WdjlF","title":"title__x53pn"};